import { filter, findIndex } from 'lodash';
import { ViewFormComponentDataService } from './shared/view-form-component-data.service';
import { ViewFormFormService } from './shared/view-form.form.service';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  HostListener,
  ViewChild,
  TemplateRef,
  Input,
  OnDestroy
} from '@angular/core';
import {
  Forma,
  ConfirmComponent,
  SubForma,
  FormaGeneral,
  ControlGeneral,
  FormaTabla,
  CondicionForma,
  CondicionDocumento,
  VersionForma,
  AsociacionTareaForma,
  Const,
  BaseControl,
  OrdenPestanas,
  Pestana,
  Documentos_Fomrulario,
  PestanasModificables
} from '@app/shared';
import { DragulaService } from 'ng2-dragula';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthenticationService } from '@app/core';
import { Subject } from 'rxjs';
// Tipo de modal a abrir
// tslint:disable-next-line: max-line-length
type typeModal = 'asociation' | 'condiction' | 'check_list' | 'visibleColumns' | 'documents' | 'duplicate' | 'revisions' | 'special_radication';

export interface OpcionesEspeciales {
  orden_pestanas: OrdenPestanas[];
  pestanas_modificables?: PestanasModificables[];
}

@Component({
  selector: 'iw-view-form',
  templateUrl: './view-form.component.html',
  styleUrls: ['./view-form.component.scss'],
  providers: [ViewFormComponentDataService, ViewFormFormService]
})
export class ViewFormComponent implements OnInit, OnDestroy {
  // Define si es un nuevo componente
  @Input() newComponent = true;
  // Version del componente
  @Input() rowVersion: FormaTabla;
  // Contiene las formas y sus versiones
  @Input() formsVersions: Array<FormaTabla>;
  // Nombre del componente
  nameComponent = '';
  // Alias del componente
  aliasComponent = '';
  // Mensaje de guardar componente
  messaggeLoading = 'Procesando solicitud';
  // Descripcion del compoente
  descriptionComponent = '';
  // Pregunta de la modal
  question = '';
  // Tipo de accion a realizar
  typeAccion = '';
  // Index del formulario seleccionado
  indexSelectForm = -1;
  // Orden de los formularios
  orderSubForm = 2;
  // Id del formulario
  idformVersion = 0;
  idForm = 0;
  idFormCheckList = 0;
  // Id del componente
  idComponent = 0;
  // Abre el compoennte de vista previa
  preview = false;
  // Abre el formulario de creacion de formularios
  newForm = false;
  // Define si se agrega un nuevo formulario
  addForm = true;
  // Define si se agrega un nuevo formulario
  updateCheckList = false;
  // Controla el evento de carga
  loadingProcess = false;
  // Forzar guardado
  forzar_guardado = false;
  // Guarda los documentos del formulario del componente documents
  documentos_formulario: any[] = [];
  // número máximo de documentos a interactuar
  maxDocs: number;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    delete: false,
    review: false,
    buildForms: false
  };
  // Define el nombre de las pestañas del componente de documentos
  windowName = 'Estructura de radicado';
  // Contiene el compponente
  component: Forma;
  // Contiene las versiones de el componente
  versions: Array<VersionForma>;
  // Contiene los formularios
  subForms: Array<SubForma> = [];
  // Formulario seleccionado
  formSelect: SubForma;
  //Referencia a los documentos del formulario
  document_form: Documentos_Fomrulario[] = [];
  // Contiene los controles del formulario de configuración de revisiones
  controlsRevisions: BaseControl<any>[];
  // Referencia de la modal
  modalRef: BsModalRef;
  // formulario que valiada el alias
  formAlias: FormGroup = new FormGroup({
    alias: new FormControl('', [Validators.pattern('^[a-zA-Z_]*$'), Validators.required])
  });
  // Informacion del formulario
  // Contiene los nombres de la pestañas
  tabsName = {
    revisiones: 'Aprobar / Firmar documentos',
    formularios: 'Formularios',
    gestion_documentos: 'Generar / Subir Documentos',
    radicacion: 'Radicar / Asociar documentos',
    anexos: 'Anexos'
  };
  specialOptions: OpcionesEspeciales;
  // Arreglo de pestañas modificables
  modifyWindow: any[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al template de la modal
  @ViewChild('templateAccion') private templateAccion: TemplateRef<any>;
  // Referencia al template de la modal de asociaciones de formas
  @ViewChild('templateAssociationForm') private templateAssociationForm: TemplateRef<any>;
  // Referencia al template de la modal de condiciones de formularios
  @ViewChild('templateConditionsForm') private templateConditionsForm: TemplateRef<any>;
  // Referencia al template de la modal de duplicacion de forma
  @ViewChild('templateDuplicate') private templateDuplicate: TemplateRef<any>;
  // Referencia al template de la modal de condiciones de documentos
  @ViewChild('templateConditionsDocs') private templateConditionsDocs: TemplateRef<any>;
  // Referencia al template de la modal de columans visibles
  @ViewChild('templateVisibleColumns') private templateVisibleColumns: TemplateRef<any>;
  // Referencia al template de la modal de lista de chequeo
  @ViewChild('templateCheckList') private templateCheckList: TemplateRef<any>;
  // Referencia al template de la modal de configuracion de revisiones
  @ViewChild('templateRevisions') private templateRevisions: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;
  // Referencia al componente de radicación especial
  @ViewChild('templateSpecial') private templateSpecial: ConfirmComponent;
  // salida del evento de cerrar
  @Output() closeE: EventEmitter<boolean> = new EventEmitter();
  // salida del evento de guardar
  @Output() save: EventEmitter<boolean> = new EventEmitter();
  // salida del evento de eliminar
  @Output() delete: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private ds: DragulaService,
    private modalService: BsModalService,
    private vfcds: ViewFormComponentDataService,
    private toastr: ToastrService,
    private as: AuthenticationService,
    private vffs: ViewFormFormService,
  ) {
    ds.dropModel.subscribe((data: any[]) => {
      this.reorder();
    });
  }

  ngOnInit() {

    // determina los permisos del usuario en sesion
    this.activateAction.buildForms = this.as.confirmPermission(
      Const.types_permissions.administrationForms,
      Const.types_action_permissions.buildForms,
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationForms,
      Const.types_action_permissions.review,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationForms,
      Const.types_action_permissions.delete,
    );

    if (!this.activateAction.buildForms) {
      this.formAlias.disable();
    }

    if (this.newComponent) {
      this.specialOptions = {
        orden_pestanas: [],
        pestanas_modificables: []
      };
      this.component = {
        id: this.getIdform(),
        nombre: this.nameComponent,
        alias: this.aliasComponent,
        descripcion: '',
        orden: 1,
        version: 1,
        estilo: {
          cargarInformacion: false,
          anexos: false,
          remision: false,
          remision_validar_sede: false,
          funcionarios: false, 
          special_radication: false, 
          solicitar_dependencias_radicacion_especial: false,
          condiciones_documentos: [],
        },
        tabla: false,
        documento: false,
        sub_formas: [],
        sub_formulario: null,
        condicion: false,
        condiciones: [],
        asociaciones: [],
        radicado: false,
        numero_registros: 0,
      };
      this.apliIdform();
    } else {
      this.versions = this.rowVersion.versiones;
      this.versions.sort((a, b) => a.version - b.version);
      this.vfcds.getForm(this.rowVersion.id).subscribe(res => {
        let tmpModifiableWindow: any[] = [];
        let anexos = {}; 
        let formulario = {};
        let revisiones = {};
        let special_radication = {};
        let copy = {};
        let remision = {};
        let document = {};
        let radicade = {};
        let sendedBy = {};
        this.component = res;
        formulario['modificable'] = false;
        formulario['nombre'] = 'Formulario';
        formulario['orden'] = 0;
        formulario['pestana'] = 'formularios';
        formulario['requerido'] = false;
        tmpModifiableWindow.push(formulario)
        if(this.component.estilo['anexos']){
          anexos['modificable'] = false;
          anexos['nombre'] = 'Anexos';
          anexos['orden'] = 0;
          anexos['pestana'] = 'anexos';
          anexos['requerido'] = false;
          tmpModifiableWindow.push(anexos)
        }
        if(this.component.estilo['revisiones']){
          revisiones['modificable'] = false;
          revisiones['nombre'] = 'Aprobar / Firmar documento';
          revisiones['orden'] = 0;
          revisiones['pestana'] = 'revisiones';
          revisiones['requerido'] = false;
          tmpModifiableWindow.push(revisiones)
        }
        if(this.component.estilo['special_radication']){
          special_radication['modificable'] = false;
          special_radication['nombre'] = 'Radicación especial';
          special_radication['orden'] = 0;
          special_radication['pestana'] = 'radicacion_especial';
          special_radication['requerido'] = false;
          tmpModifiableWindow.push(special_radication)
        }
        if(this.component.estilo['remision']){
          copy['modificable'] = false;
          copy['nombre'] = 'Copia a';
          copy['orden'] = 0;
          copy['pestana'] = 'con_copia_a';
          copy['requerido'] = false;
          tmpModifiableWindow.push(copy)
        }
        if(this.component.estilo['funcionarios']){
          remision['modificable'] = false;
          remision['nombre'] = 'Remisión';
          remision['orden'] = 0;
          remision['pestana'] = 'remision_funcionarios';
          remision['requerido'] = false;
          tmpModifiableWindow.push(remision)
        }
        if(this.component.estilo['enviado_por']){
          sendedBy['modificable'] = false;
          sendedBy['nombre'] = 'Envio por';
          sendedBy['orden'] = 0;
          sendedBy['pestana'] = 'enviado_por';
          sendedBy['requerido'] = false;
          tmpModifiableWindow.push(sendedBy)
        }
        if(this.component.documento){
          document['modificable'] = false;
          document['nombre'] = 'Generar / Subir documentos';
          document['orden'] = 0;
          document['pestana'] = 'gestion_documentos';
          document['requerido'] = false;
          tmpModifiableWindow.push(document)
        }
        if(this.component.radicado){
          radicade['modificable'] = false;
          radicade['nombre'] = 'Radicar / Asociar documentos';
          radicade['orden'] = 0;
          radicade['pestana'] = 'radicacion';
          radicade['requerido'] = false;
          tmpModifiableWindow.push(radicade)
        }
        if(this.component.estilo.pestanas_modificables && this.component.estilo.pestanas_modificables.length){
          this.component.estilo.pestanas_modificables.forEach((pm: any) => {
            tmpModifiableWindow.forEach(tmp=>{
              if(tmp.pestana == pm.pestana && pm.modificable){
                tmp.modificable = true;
              }
            })
          });
        }
        this.document_form = this.component.documentos_formulario
        this.specialOptions = {
          orden_pestanas: this.component.estilo.orden_pestanas && this.component.estilo.orden_pestanas.length ?
                        this.component.estilo.orden_pestanas
                      : [],
          pestanas_modificables: tmpModifiableWindow && tmpModifiableWindow.length ? tmpModifiableWindow : []
        };
        for (let index = 0; index < this.component.sub_formas.length; index++) {
          if (this.component.sub_formas[index].tabla) {
            this.component.sub_formas[index]
              .configuracion_tabla = this.creationTable(this.component.sub_formas[index]);
          }
        }
        this.idForm = this.component.id;
        this.idformVersion = this.component.id;
        this.subForms = this.component.sub_formas;
        this.subForms.sort((a, b) => a.orden - b.orden);
        this.nameComponent = res.nombre;
        this.aliasComponent = res.alias;
        this.formAlias.controls['alias'].setValue(res.alias);
        this.descriptionComponent = res.descripcion;
        this.orderSubForm = this.getOrderMax();
        if (Object.keys(this.component.estilo).length) {
          if (!this.component.estilo['cargarInformacion']) {
            this.component.estilo['cargarInformacion'] = false;
          }
          if (!this.component.estilo['anexos']) {
            this.component.estilo['anexos'] = false;
          }
          if (!this.component.estilo['remision']) {
            this.component.estilo['remision'] = false;
          }
          if (!this.component.estilo['funcionarios']) {
            this.component.estilo['funcionarios'] = false;
          }
          if (!this.component.estilo['special_radication']) {
            this.component.estilo['special_radication'] = false;
          }
        } else {
          this.component.estilo = {
            cargarInformacion: false,
            anexos: false,
            condiciones_documentos: [],
          };
        }
      });
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Controla los eventos al presionar las teclas
   *
   * @param {*} e
   * @memberof ViewFormComponent
   */
  @HostListener('window:keyup', ['$event'])
  onKeyUp(e: any) {
    if (!this.newForm) {
      switch (e.keyCode) {
        // Escape
        case 27:
          this.action('close');
          break;
        // N
        case 78:
          if (e.altKey) {
            this.newForm = true;
          }
          break;
        // T
        case 84:
          if (e.altKey) {
            this.newForm = false;
          }
          break;
      }
    }
  }

  /**
   * Controla el focus out de los campos de descripcion y nombre del componente
   * y guarda esta informacion
   *
   * @param {*} data
   * @param {string} [field='name']
   * @memberof ViewFormComponent
   */
  onFocusOut(data: any, field: string = 'name') {
    switch (field) {
      case 'name':
        this.nameComponent = data.target.value.trim();
        this.component.nombre = this.nameComponent;
        break;
      case 'descripction':
        this.descriptionComponent = data.target.value;
        this.component.descripcion = this.descriptionComponent;
        break;
      case 'alias':
        this.aliasComponent = data.target.value;
        this.component.alias = this.aliasComponent;
        break;
    }
  }

  /**
   * Reinicia el id de los formularios
   *
   * @memberof ViewFormComponent
   */
  resetIdForm() {
    this.idComponent = 0;
  }

  /**
   * Retorna el siguiente id de formulario
   *
   * @returns {number}
   * @memberof ViewFormComponent
   */
  getIdform(): number {
    return this.idComponent - 1;
  }

  /**
   * Aplica el un nuevo id
   *
   * @memberof ViewFormComponent
   */
  apliIdform() {
    this.idComponent--;
  }

  /**
   * Define la pregunta de la modal
   *
   * @param {string} type
   * @memberof ViewFormComponent
   */
  action(type: string) {
    this.typeAccion = type;
    switch (this.typeAccion) {
      case 'close':
        if (this.newComponent) {
          this.question = '¿Realmente desea cancelar la creacion de la nueva forma?';
        } else {
          this.question = '¿Realmente desea cancelar la edicion de la forma: ' + this.nameComponent + '?';
        }
        break;
      case 'saved':
        this.question = '¿Realmente desea guardar la forma?';
        break;
      case 'deleteForm':
        this.question = '¿Realmente desea eliminar el formulario seleccionado?';
        break;
    }
    this.confirmAction.open();
  }

  /**
   * reaiza la accion despues de la respuesta de la modal
   *
   * @param {boolean} res
   * @memberof ViewFormComponent
   */
  actionComfirmClose(res: boolean) {
    if (res) {
      switch (this.typeAccion) {
        case 'close':
          this.close();
          break;
        case 'saved':
          this.saveComponent();
          break;
        case 'deleteForm':
          this.deleteForm();
          break;
      }
    }
    this.typeAccion = '';
    this.question = '';
  }

  /**
   * Emite el evento de cierre para el compoente de creacion de compoente
   *
   * @memberof ViewFormComponent
   */
  close() {
    delete this.component;
    this.resetIdForm();
    this.closeE.emit(true);
  }

  /**
   * Cierra el componente de creacion de formulario
   *
   * @param {boolean} data
   * @memberof ViewFormComponent
   */
  closeForm(data: boolean) {
    if (data) {
      this.newForm = false;
      delete this.formSelect;
    }
  }

  /**
   * Controla la accion de guardar y modificar del componente de creacion de formularios
   *
   * @param {(SubForma | SubForma[])} newForm
   * @memberof ViewFormComponent
   */
  controlSaveForm(newForm: SubForma | SubForma[]) {
    if (Array.isArray(newForm)) {
      newForm.forEach(form => {
        if (this.addForm) {
          this.saveForm(form);
        } else {
          const index = findIndex(this.component.sub_formas, {id_forma: form.id_forma});
          if (index !== -1) {
            this.updateForm(form, false, index);
          } else {
            this.saveForm(form);
          }
        }
      });
    } else {
      if (this.addForm) {
        this.saveForm(newForm);
      } else {
        this.updateForm(newForm);
      }
    }
  }

  /**
   * Guarda el nuevo formulario en el compoente
   *
   * @param {SubForma} newForm
   * @memberof ViewFormComponent
   */
  saveForm(newForm: SubForma, checkList: boolean = false) {
    if (newForm.tabla) {
      newForm.configuracion_tabla = this.creationTable(newForm);
    }
    this.component.sub_formas.push(newForm);
    const orderAt = this.orderSubForm - 1;

    if (this.component.orden === orderAt) {
      this.component.sub_formulario = newForm.id_forma;
    } else {

      for (let index = 0; index < this.component.sub_formas.length; index++) {
        if (this.component.sub_formas[index].orden === orderAt) {
          this.component.sub_formas[index].sub_formulario = newForm.id_forma;
        }
      }
    }

    this.subForms = this.component.sub_formas;
    this.orderSubForm++;
    this.apliIdform();
    this.reorder();
    if (!checkList) {
      this.closeForm(true);
    } else {
      this.closeModal();
    }
  }

  /**
   * Reordena los fromularios en el componente
   *
   * @memberof ViewFormComponent
   */
  reorder() {
    // if (!this.newForm) {
      for (let indexF = 0; indexF < this.subForms.length; indexF++) {
        this.subForms[indexF].orden = indexF + 2;
      }

      if (this.component) {
        for (let indexF = 0; indexF < this.subForms.length; indexF++) {
          const orderAT = this.subForms[indexF].orden - 1;
          if (orderAT === this.component.orden) {
            this.component.sub_formulario = this.subForms[indexF].id_forma;
          } else {
            for (let indexSF = 0; indexSF < this.subForms.length; indexSF++) {
              if (orderAT === this.subForms[indexSF].orden) {
                this.subForms[indexSF].sub_formulario = this.subForms[indexF].id_forma;
                break;
              }
            }
          }
          if (indexF + 1 === this.subForms.length) {
            this.subForms[indexF].sub_formulario = null;
          }
        }
        this.component.sub_formas = this.subForms;
      }
    // }
  }

  /**
   * Accion cuando se selecciona un formulario y muestra la modal de acciones
   *
   * @param {SubForma} form
   * @param {number} index
   * @memberof ViewFormComponent
   */
  editForm(form: SubForma, index: number) {
    if (this.activateAction.buildForms) {
      this.formSelect = form;
      this.indexSelectForm = index;
      if (this.formSelect.tabla) {
        this.modalRef = this.modalService.show(this.templateAccion, { class: 'modal-lg' });
      } else {
        this.modalRef = this.modalService.show(this.templateAccion, { class: 'modal-md' });
      }
    } else {
      this.toastr.error('Usted no posee permisos para construcción de formas dinámicas', 'Permiso denegado');
    }
  }

  /**
   * Actualiza el formulario seleccionado
   *
   * @param {SubForma} form
   * @memberof ViewFormComponent
   */
  updateForm(form: SubForma, chekList: boolean = false, index: number = -1) {
    if (form.tabla) {
      form.configuracion_tabla = this.creationTable(form);
    }
    this.component.sub_formas[index !== -1 ? index : this.indexSelectForm] = form;
    this.subForms[index !== -1 ? index : this.indexSelectForm] = form;
    if (index === -1) {
      this.indexSelectForm = -1;
    }
    if (!chekList) {
      this.closeForm(true);
    } else {
      delete this.formSelect;
      this.closeModal();
    }
  }

  /**
   * Elimian el formulario seleccionado
   *
   * @memberof ViewFormComponent
   */
  private deleteForm() {
    if (this.indexSelectForm !== -1) {
      this.subForms.splice(this.indexSelectForm, 1);
      this.indexSelectForm = -1;
      this.modalRef.hide();
    }
    this.reorder();
  }

  /**
   * Crea la configuracion de la tabla del formulario
   *
   * @param {SubForma} form
   * @returns {*}
   * @memberof ViewFormComponent
   */
  creationTable(form: SubForma): any {

    const columns = {};

    form.campos.forEach(control => {
      switch (control.tipo_campo.nombre) {
        case 'textarea':
        case 'checkbox':
          columns[control.nombre_campo] = {
            editable: false,
            addable: false,
            sort: false,
            title: control.label,
            filter: false
          };
          break;
        default:
          if (control.tipo_campo.nombre !== 'label') {
            columns[control.nombre_campo] = {
              editable: false,
              addable: false,
              sort: false,
              title: control.label,
              filter: {
                inputClass: 'form-control',
              },
            };
          }
          break;
      }
    });

    const settings = {
      mode: 'external',
      noDataMessage: '',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: columns
    };

    return settings;

  }

  /**
   * Guarda o modifica el componente
   *
   * @memberof ViewFormComponent
   */
  saveComponent() {
    const validForm = this.validForm();
    if (validForm) {
      const componentF: Array<FormaGeneral> = [];
      this.loadingProcess = true;
      if (
        this.component.documento ||
        this.component.radicado ||
        this.component.estilo['anexos'] ||
        this.component.estilo['revisiones'] ||
        this.component.estilo['funcionarios'] ||
        this.component.estilo['remision'] ||
        this.component.estilo['special_radication'] ||
        this.component.estilo['en_respuesta_de']
      ) {
        if (this.specialOptions.orden_pestanas.length) {
          this.component.estilo['orden_pestanas'] = this.formatListOrderTabs(this.specialOptions.orden_pestanas);
        } else {
          this.component.estilo['orden_pestanas'] = null;
        }
        if(this.specialOptions.pestanas_modificables && this.specialOptions.pestanas_modificables.length){
          let anexos = {}; 
          let revisiones = {};
          let special_radication = {};
          let copy = {};
          let remision = {};
          let respuesta_de = {};
          let document = {};
          let radicade = {};
          if(this.component.estilo['anexos'] && !this.modifyWindow.find(x=> x.pestana == 'anexos')){
            anexos['modificable'] = false;
            anexos['nombre'] = 'Anexos';
            anexos['orden'] = 0;
            anexos['pestana'] = 'anexos';
            anexos['requerido'] = false;
            this.modifyWindow.push(anexos)
          }else if(!this.component.estilo['anexos'] && this.modifyWindow.find(x=> x.pestana == 'anexos')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'anexos');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.estilo['revisiones']  && !this.modifyWindow.find(x=> x.pestana == 'revisiones')){
            revisiones['modificable'] = false;
            revisiones['nombre'] = 'Aprobar / Firmar documento';
            revisiones['orden'] = 0;
            revisiones['pestana'] = 'revisiones';
            revisiones['requerido'] = false;
            this.modifyWindow.push(revisiones)
          }else if(!this.component.estilo['revisiones'] && this.modifyWindow.find(x=> x.pestana == 'revisiones')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'revisiones');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.estilo['special_radication'] && !this.modifyWindow.find(x=> x.pestana == 'radicacion_especial')){
            special_radication['modificable'] = false;
            special_radication['nombre'] = 'Radicación especial';
            special_radication['orden'] = 0;
            special_radication['pestana'] = 'radicacion_especial';
            special_radication['requerido'] = false;
            this.modifyWindow.push(special_radication)
          }else if(!this.component.estilo['special_radication'] && this.modifyWindow.find(x=> x.pestana == 'radicacion_especial')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'radicacion_especial');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.estilo['remision'] && !this.modifyWindow.find(x=> x.pestana == 'con_copia_a')){
            copy['modificable'] = false;
            copy['nombre'] = 'Copia a';
            copy['orden'] = 0;
            copy['pestana'] = 'con_copia_a';
            copy['requerido'] = false;
            this.modifyWindow.push(copy)
          }else if(!this.component.estilo['remision'] && this.modifyWindow.find(x=> x.pestana == 'con_copia_a')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'con_copia_a');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.estilo['funcionarios'] && !this.modifyWindow.find(x=> x.pestana == 'remision_funcionarios')){
            remision['modificable'] = false;
            remision['nombre'] = 'Remisión';
            remision['orden'] = 0;
            remision['pestana'] = 'remision_funcionarios';
            remision['requerido'] = false;
            this.modifyWindow.push(remision)
          }else if(!this.component.estilo['funcionarios'] && this.modifyWindow.find(x=> x.pestana == 'remision_funcionarios')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'remision_funcionarios');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.estilo['en_respuesta_de'] && !this.modifyWindow.find(x=> x.pestana == 'en_respuesta_de')){
            respuesta_de['modificable'] = false;
            respuesta_de['nombre'] = 'En respuesta de';
            respuesta_de['orden'] = 0;
            respuesta_de['pestana'] = 'en_respuesta_de';
            respuesta_de['requerido'] = false;
            this.modifyWindow.push(respuesta_de)
          }else if(!this.component.estilo['en_respuesta_de'] && this.modifyWindow.find(x=> x.pestana == 'en_respuesta_de')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'en_respuesta_de');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.documento && !this.modifyWindow.find(x=> x.pestana == 'gestion_documentos')){
            document['modificable'] = false;
            document['nombre'] = 'Generar / Subir documentos';
            document['orden'] = 0;
            document['pestana'] = 'gestion_documentos';
            document['requerido'] = false;
            this.modifyWindow.push(document)
          }else if(!this.component.documento && this.modifyWindow.find(x=> x.pestana == 'gestion_documentos')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'gestion_documentos');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.radicado && !this.modifyWindow.find(x=> x.pestana == 'radicacion')){
            radicade['modificable'] = false;
            radicade['nombre'] = 'Radicar / Asociar documentos';
            radicade['orden'] = 0;
            radicade['pestana'] = 'radicacion';
            radicade['requerido'] = false;
            this.modifyWindow.push(radicade)
          }else if(!this.component.radicado && this.modifyWindow.find(x=> x.pestana == 'radicacion')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'radicacion');
            this.modifyWindow.splice(index,1);
          }
          this.component.estilo['pestanas_modificables'] = this.modifyWindow;
        }else{
          let anexos = {}; 
          let revisiones = {};
          let special_radication = {};
          let copy = {};
          let remision = {};
          let respuesta_de = {};
          let document = {};
          let radicade = {};
          if(this.component.estilo['anexos'] && !this.modifyWindow.find(x=> x.pestana == 'anexos')){
            anexos['modificable'] = false;
            anexos['nombre'] = 'Anexos';
            anexos['orden'] = 0;
            anexos['pestana'] = 'anexos';
            anexos['requerido'] = false;
            this.modifyWindow.push(anexos)
          }else if(!this.component.estilo['anexos'] && this.modifyWindow.find(x=> x.pestana == 'anexos')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'anexos');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.estilo['revisiones']  && !this.modifyWindow.find(x=> x.pestana == 'revisiones')){
            revisiones['modificable'] = false;
            revisiones['nombre'] = 'Aprobar / Firmar documento';
            revisiones['orden'] = 0;
            revisiones['pestana'] = 'revisiones';
            revisiones['requerido'] = false;
            this.modifyWindow.push(revisiones)
          }else if(!this.component.estilo['revisiones'] && this.modifyWindow.find(x=> x.pestana == 'revisiones')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'revisiones');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.estilo['special_radication'] && !this.modifyWindow.find(x=> x.pestana == 'radicacion_especial')){
            special_radication['modificable'] = false;
            special_radication['nombre'] = 'Radicación especial';
            special_radication['orden'] = 0;
            special_radication['pestana'] = 'radicacion_especial';
            special_radication['requerido'] = false;
            this.modifyWindow.push(special_radication)
          }else if(!this.component.estilo['special_radication'] && this.modifyWindow.find(x=> x.pestana == 'radicacion_especial')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'radicacion_especial');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.estilo['remision'] && !this.modifyWindow.find(x=> x.pestana == 'con_copia_a')){
            copy['modificable'] = false;
            copy['nombre'] = 'Copia a';
            copy['orden'] = 0;
            copy['pestana'] = 'con_copia_a';
            copy['requerido'] = false;
            this.modifyWindow.push(copy)
          }else if(!this.component.estilo['remision'] && this.modifyWindow.find(x=> x.pestana == 'con_copia_a')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'con_copia_a');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.estilo['funcionarios'] && !this.modifyWindow.find(x=> x.pestana == 'remision_funcionarios')){
            remision['modificable'] = false;
            remision['nombre'] = 'Remisión';
            remision['orden'] = 0;
            remision['pestana'] = 'remision_funcionarios';
            remision['requerido'] = false;
            this.modifyWindow.push(remision)
          }else if(!this.component.estilo['funcionarios'] && this.modifyWindow.find(x=> x.pestana == 'remision_funcionarios')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'remision_funcionarios');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.estilo['en_respuesta_de'] && !this.modifyWindow.find(x=> x.pestana == 'en_respuesta_de')){
            respuesta_de['modificable'] = false;
            respuesta_de['nombre'] = 'En respuesta de';
            respuesta_de['orden'] = 0;
            respuesta_de['pestana'] = 'en_respuesta_de';
            respuesta_de['requerido'] = false;
            this.modifyWindow.push(respuesta_de)
          }else if(!this.component.estilo['en_respuesta_de'] && this.modifyWindow.find(x=> x.pestana == 'en_respuesta_de')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'en_respuesta_de');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.documento && !this.modifyWindow.find(x=> x.pestana == 'gestion_documentos')){
            document['modificable'] = false;
            document['nombre'] = 'Generar / Subir documentos';
            document['orden'] = 0;
            document['pestana'] = 'gestion_documentos';
            document['requerido'] = false;
            this.modifyWindow.push(document)
          }else if(!this.component.documento && this.modifyWindow.find(x=> x.pestana == 'gestion_documentos')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'gestion_documentos');
            this.modifyWindow.splice(index,1);
          }
          if(this.component.radicado && !this.modifyWindow.find(x=> x.pestana == 'radicacion')){
            radicade['modificable'] = false;
            radicade['nombre'] = 'Radicar / Asociar documentos';
            radicade['orden'] = 0;
            radicade['pestana'] = 'radicacion';
            radicade['requerido'] = false;
            this.modifyWindow.push(radicade)
          }else if(!this.component.radicado && this.modifyWindow.find(x=> x.pestana == 'radicacion')){
            let index = this.modifyWindow.findIndex(x=> x.pestana == 'radicacion');
            this.modifyWindow.splice(index,1);
          }
          this.component.estilo['pestanas_modificables'] = this.modifyWindow;
        }
      } else {
        this.component.estilo['orden_pestanas'] = null;
        this.component.estilo['pestanas_modificables'] = null;
      }
      this.component.estilo['numeros_documentos'] = this.maxDocs;
      componentF.push({
        id_forma: this.component.id,
        nombre: this.component.nombre.trim(),
        alias: this.component.alias,
        descripcion: this.component.descripcion,
        estilo: this.component.estilo,
        orden: this.component.orden,
        tabla: this.component.tabla,
        documento: this.component.documento,
        campos: [],
        sub_formulario: this.component.sub_formulario,
        condicion: this.component.condicion,
        condiciones: this.component.condiciones,
        asociaciones: this.component.asociaciones,
        numero_registros: 0,
        radicado: this.component.radicado,
        lista_chequeo: this.validCheckList(),
        documentos_formulario: this.document_form
      });


      this.component.sub_formas.forEach(forma => {
        const controls: Array<ControlGeneral> = [];
        forma.campos.forEach(control => {
          controls.push({
            nombre_campo: control.nombre_campo,
            tipo_campo: control.tipo_campo.id,
            label: control.label,
            espacio: control.espacio,
            requerido: control.requerido,
            placeholder: control.placeholder,
            tooltip: control.tooltip,
            orden: control.orden,
            tipos_documentales_selector: control.tipos_documentales_selector,
            validaciones: control.validaciones,
            propiedades: control.propiedades,
            estilos: control.estilos,
            lista_maestra: control.lista_maestra[0] ? control.lista_maestra[0].id : null,
            alias: control.alias,
            sincronizado: control.sincronizado,
            dato_radicacion: control.dato_radicacion //Se agrega campo para el dato de radicacion
          });
        }); 

        componentF.push({
          id_forma: forma.id_forma,
          nombre: forma.nombre,
          alias: forma.alias,
          descripcion: forma.descripcion ? forma.descripcion : '',
          estilo: forma.estilo,
          orden: forma.orden,
          tabla: forma.tabla,
          documento: false,
          campos: controls,
          sub_formulario: forma.sub_formulario,
          condicion: false,
          condiciones: forma.condiciones,
          asociaciones: [],
          numero_registros: forma.numero_registros,
          radicado: false,
          lista_chequeo: false,
          control_documentos: forma.control_documentos
        });
      });
      if (this.newComponent) {
        this.messaggeLoading = 'Creando nueva forma';
      } else {
        this.messaggeLoading = 'Modificando la forma ' + this.component.nombre;
      }
      this.vfcds.saveForm(componentF, !this.newComponent, this.component.id, this.forzar_guardado).subscribe(res => {
        this.loadingProcess = false;
        this.messaggeLoading = '';
        this.save.emit(res);
        this.closeE.emit(res);
      });
    }
  }

  /**
   * Retorna el index maximo de los formularios dentro del componente
   *
   * @returns {number}
   * @memberof ViewFormComponent
   */
  getOrderMax(): number {
    let orderMax = 0;
    this.subForms.forEach(subForm => {
      if (subForm.orden > orderMax) {
        orderMax = subForm.orden;
      }
    });
    return orderMax + 1;
  }

  /**
   * Controla y refactoriza el componete de la version seleccioanda
   *
   * @param {*} data
   * @memberof ViewFormComponent
   */
  changeVersion(data: any) {
    if (this.activateAction.buildForms || this.activateAction.review) {
      const idForm = data.target.value;
      this.vfcds.getForm(idForm).subscribe(res => {
        this.component = res;
        let tmpModifiableWindow: any[] = [];
        let anexos = {}; 
        let revisiones = {};
        let special_radication = {};
        let copy = {};
        let remision = {};
        let respuesta_de = {};
        let document = {};
        let radicade = {};
        this.component = res;
        if(this.component.estilo['anexos']){
          anexos['modificable'] = false;
          anexos['nombre'] = 'Anexos';
          anexos['orden'] = 0;
          anexos['pestana'] = 'anexos';
          anexos['requerido'] = false;
          tmpModifiableWindow.push(anexos)
        }
        if(this.component.estilo['revisiones']){
          revisiones['modificable'] = false;
          revisiones['nombre'] = 'Aprobar / Firmar documento';
          revisiones['orden'] = 0;
          revisiones['pestana'] = 'revisiones';
          revisiones['requerido'] = false;
          tmpModifiableWindow.push(revisiones)
        }
        if(this.component.estilo['special_radication']){
          special_radication['modificable'] = false;
          special_radication['nombre'] = 'Radicación especial';
          special_radication['orden'] = 0;
          special_radication['pestana'] = 'radicacion_especial';
          special_radication['requerido'] = false;
          tmpModifiableWindow.push(special_radication)
        }
        if(this.component.estilo['remision']){
          copy['modificable'] = false;
          copy['nombre'] = 'Copia a';
          copy['orden'] = 0;
          copy['pestana'] = 'con_copia_a';
          copy['requerido'] = false;
          tmpModifiableWindow.push(copy)
        }
        if(this.component.estilo['funcionarios']){
          remision['modificable'] = false;
          remision['nombre'] = 'Remisión';
          remision['orden'] = 0;
          remision['pestana'] = 'remision_funcionarios';
          remision['requerido'] = false;
          tmpModifiableWindow.push(remision)
        }
        if(this.component.estilo['en_respuesta_de']){
          respuesta_de['modificable'] = false;
          respuesta_de['nombre'] = 'En respuesta de';
          respuesta_de['orden'] = 0;
          respuesta_de['pestana'] = 'en_respuesta_de';
          respuesta_de['requerido'] = false;
          tmpModifiableWindow.push(respuesta_de)
        }
        if(this.component.documento){
          document['modificable'] = false;
          document['nombre'] = 'Generar / Subir documentos';
          document['orden'] = 0;
          document['pestana'] = 'gestion_documentos';
          document['requerido'] = false;
          tmpModifiableWindow.push(document)
        }
        if(this.component.radicado){
          radicade['modificable'] = false;
          radicade['nombre'] = 'Radicar / Asociar documentos';
          radicade['orden'] = 0;
          radicade['pestana'] = 'radicacion';
          radicade['requerido'] = false;
          tmpModifiableWindow.push(radicade)
        }
        if(this.component.estilo.pestanas_modificables && this.component.estilo.pestanas_modificables.length){
          this.component.estilo.pestanas_modificables.forEach((pm: any) => {
            tmpModifiableWindow.forEach(tmp=>{
              if(tmp.pestana == pm.pestana && pm.modificable){
                tmp.modificable = true;
              }
            })
          });
        }
        this.specialOptions = {
          orden_pestanas: this.component.estilo.orden_pestanas && this.component.estilo.orden_pestanas.length ?
                        this.component.estilo.orden_pestanas
                      : [],
          pestanas_modificables: tmpModifiableWindow && tmpModifiableWindow.length ? tmpModifiableWindow : []
        };
        for (let index = 0; index < this.component.sub_formas.length; index++) {
          if (this.component.sub_formas[index].tabla) {
            this.component.sub_formas[index]
              .configuracion_tabla = this.creationTable(this.component.sub_formas[index]);
          }
        }
        this.idForm = this.component.id;
        this.idformVersion = this.component.id;
        this.subForms = this.component.sub_formas;
        this.nameComponent = res.nombre;
        this.aliasComponent = res.alias;
        this.formAlias.controls['alias'].setValue(res.alias);
        this.descriptionComponent = res.descripcion;
        this.orderSubForm = this.getOrderMax();
      });
    } else {
      this.toastr.error('Usted no posee permisos para construcción o ver las formas dinámicas', 'Permiso denegado');
    }
  }

  /**
   * Elimina el componente
   *
   * @param {boolean} response
   * @memberof ViewFormComponent
   */
  deleteComponent(response: boolean) {
    if (this.activateAction.delete) {
      if (response) {
        this.messaggeLoading = 'Procesando solicitud';
        this.loadingProcess = true;
        if (this.idForm > 0) {
          this.messaggeLoading = 'Eliminando Forma ' + this.component.nombre + ' con la version ' +
            this.component.version;
          this.vfcds.deleteForm(this.idForm).subscribe(res => {
            if (res) {
              this.delete.emit(true);
              this.closeE.emit(true);
            }
            this.messaggeLoading = '';
            this.loadingProcess = false;
          });
        }
      }
    } else {
      this.toastr.error(
        'Usted no posee permisos para eliminar formas dinámicas',
        'Permiso denegado'
      );
    }
  }

  /**
   * Abre el componente de vista previa
   *
   * @memberof ViewFormComponent
   */
  previewForm() {
    this.preview = true;
  }

  /**
   * Cierra el compoente de vista previa
   *
   * @memberof ViewFormComponent
   */
  closePreviewForm() {
    this.preview = false;
  }

  /**
   * Abre la modal indicada
   *
   * @param {typeModal} [modal='asociation']
   * @memberof ViewFormComponent
   */
  openModal(modal: typeModal = 'asociation') {
    switch (modal) {
      case 'asociation':
        this.modalRef = this.modalService.show(this.templateAssociationForm, { class: 'modal-lg'});
        break;
      case 'condiction':
        this.modalRef = this.modalService.show(this.templateConditionsForm, { class: 'modal-lg-personalized'});
        break;
      case 'check_list':
        this.modalRef = this.modalService.show(this.templateCheckList, { class: 'modal-lg-personalized'});
        this.updateCheckList = false;
        this.idFormCheckList = this.getIdform();
        break;
      case 'visibleColumns':
        this.modalRef.hide();
        this.modalRef = this.modalService.show(this.templateVisibleColumns, { class: 'modal-lg'});
        break;
      case 'documents':
        this.modalRef = this.modalService.show(this.templateConditionsDocs, { class: 'modal-lg-personalized'});
        break;
      case 'duplicate':
        this.modalRef = this.modalService.show(this.templateDuplicate, { class: 'modal-lg'});
        break;
      case 'revisions':
        this.controlsRevisions = this.vffs.getFormConfigRevisions(this.component.estilo['revisiones']);
        this.modalRef = this.modalService.show(this.templateRevisions, { class: 'modal-lg'});
        break;
      case 'special_radication':
        this.modalRef = this.modalService.show(this.templateSpecial, { class: 'modal-lg-personalized'});
    }
  }

  /**
   * Cierra la modal actual en ejecucion
   *
   * @memberof ViewFormComponent
   */
  closeModal() {
    this.modalRef.hide();
  }

  /**
   * Guarda las asociaciones
   *
   * @param {Array<AsociacionTareaForma>} data
   * @memberof ViewFormComponent
   */
  savedAssociations(data: Array<AsociacionTareaForma>) {
    this.component.asociaciones = data;
    this.closeModal();
  }

  /**
   * Guarda las condiciones
   *
   * @param {Array<CondicionForma>} data
   * @memberof ViewFormComponent
   */
  savedCondictions(data: Array<CondicionForma>) {
    this.component.condiciones = data;
    this.closeModal();
  }

  /**
   * Guarda las condiciones de los documentos
   *
   * @param {Array<CondicionDocumento>} data
   * @memberof ViewFormComponent
   */
  savedCondictionsDocument(data: Array<CondicionDocumento>) {
    this.component.estilo['condiciones_documentos'] = data;
    this.closeModal();
  }

  /**
   * Abre la modal de creacion de lista de chequeo o el componente de creacion de formularios
   *
   * @param {boolean} [edit=false]
   * @memberof ViewFormComponent
   */
  openCreation(edit: boolean = false) {
    if (!edit) {
      this.newForm = true;
      this.addForm = true;
      this.idForm = this.getIdform();
    } else {
      this.modalRef.hide();
      if (!this.formSelect.estilo.hasOwnProperty('tipo')) {
      this.newForm = true;
      this.addForm = false;
      } else {
        this.updateCheckList = true;
        this.modalRef = this.modalService.show(this.templateCheckList, { class: 'modal-lg-personalized'});
      }
    }
  }

  /**
   * Realiza las pertinentes validaciones de la forma a guardar
   *
   * @private
   * @returns {boolean}
   * @memberof ViewFormComponent
   */
  private validForm(): boolean {
    let valid = false;
    if (this.nameComponent && this.formAlias.controls['alias'].valid) {
      const aliasForm: string[] = [];
      const formRadicationsSystem: SubForma[] = [];
      if (this.component.sub_formas && this.component.sub_formas.length) {
        for (const form of this.component.sub_formas) {
          const indexExist = aliasForm.indexOf(form.alias);
          if (indexExist === -1) {
            aliasForm.push(form.alias);
            const fieldsRadicationsSystems = filter(
              form.campos,
              field => field.tipo_campo.nombre === 'ngSelect' && field.propiedades['tipo'] === 'RadicadosSistema'
            );
            if (fieldsRadicationsSystems && fieldsRadicationsSystems.length) {
              if (fieldsRadicationsSystems.length === 1) {
                if (formRadicationsSystem.length === 0) {
                  valid = true;
                  formRadicationsSystem.push(form);
                } else {
                  valid = false;
                  this.toastr.error(
                    'Para los campos de tipo selector con una fuente de datos de los radicados del sistema, ' +
                    'solo pueden existir uno por forma, verifique e intente de nuevo.',
                    'Información incorrecta'
                  );
                  break;
                }
              } else {
                valid = false;
                this.toastr.error(
                  'Para los campos de tipo selector con una fuente de datos de los radicados del sistema, ' +
                  'solo pueden existir uno por forma, verifique e intente de nuevo.',
                  'Información incorrecta'
                );
                break;
              }
            } else {
              valid = true;
            }
          } else {
            valid = false;
            this.toastr.error(
              'Los alias de los formularios deben ser unicos, verifique e intente de nuevo.',
              'Información incorrecta'
            );
            break;
          }
        }
      }
    } else {
      if (!this.nameComponent) {
        this.toastr.warning('Ingrese el nombre de la forma', 'Información incompleta');
      } else {
        this.toastr.warning('El alias de la forma es obligatorio, solo permite letras y guiones bajos',
                            'Información incompleta');
      }
    }
    return valid;
  }

  /**
   * Valida si la forma a crear o editar tiene listas de chequeo que cargan de una forma
   *
   * @private
   * @returns {boolean}
   * @memberof ViewFormComponent
   */
  private validCheckList(): boolean {
    let valid = false;
    if (this.component && this.component.sub_formas && this.component.sub_formas.length) {
      for (const subForm of this.component.sub_formas) {
        if (subForm.estilo.hasOwnProperty('tipo')) {
          if (subForm.estilo['tipo'] === 'TablaMaestra') {
            valid = true;
            break;
          }
        }
      }
    }
    return valid;
  }

  /**
   * Organiza el formato de la lista de orden de pestañas
   *
   * @private
   * @param {OrdenPestanas[]} tabs
   * @returns {OrdenPestanas[]}
   * @memberof ViewFormComponent
   */
  private formatListOrderTabs(tabs: OrdenPestanas[]): OrdenPestanas[] {
    if (this.component.documento) {
      this.updateListTabs(tabs, 'gestion_documentos', 'add');
    } else {
      this.updateListTabs(tabs, 'gestion_documentos', 'remove');
    }
    if (this.component.radicado) {
      this.updateListTabs(tabs, 'radicacion', 'add');
    } else {
      this.updateListTabs(tabs, 'radicacion', 'remove');
    }
    if (this.component.estilo['revisiones']) {
      this.updateListTabs(tabs, 'revisiones', 'add');
    } else {
      this.updateListTabs(tabs, 'revisiones', 'remove');
    }
    if (this.component.estilo['anexos']) {
      this.updateListTabs(tabs, 'anexos', 'add');
    } else {
      this.updateListTabs(tabs, 'anexos', 'remove');
    }
    tabs.forEach((tab, i) => {
      tab.orden = i + 1;
    });
    return tabs;
  }

  /**
   * Actualiza la lista de ordenes de pestañas agregando o quitando segun sea el caso la pestaña del orden
   *
   * @private
   * @param {Pestana} tab
   * @param {('add' | 'remove')} action
   * @memberof ViewFormComponent
   */
  private updateListTabs(orderTabs: OrdenPestanas[], tab: Pestana, action: 'add' | 'remove') {
    const exist = findIndex(orderTabs, {pestana: tab});
    if (exist === -1 && action === 'add') {
      const nextOrden = orderTabs.length ? Number(orderTabs[orderTabs.length - 1].orden) + 1 : 1;
      orderTabs.push({
        orden: nextOrden,
        pestana: tab,
        requerido: false,
        nombre: this.tabsName[tab]
      });
    } else if (exist !== -1 && action === 'remove') {
      orderTabs.splice(exist, 1);
    }
  }


  /**
   *
   *Define el nombre de las pestañas del componente de documentos
   * @param {*} name
   * @memberof ViewFormComponent
   */
  updateWindowName(name: any){
    this.windowName = name;
  }

  /**
   *Recibe los cambios en los documentos del formulario hechos en document component
   *
   * @param {*} data
   * @memberof ViewFormComponent
   */
  updateDocumentForm(data: any){
    this.documentos_formulario = data;
  }

  /**
   *Actualiza el número máximo de documentos a interactuar
   *
   * @param {*} data
   * @memberof ViewFormComponent
   */
  updateMaxDocs(data: any){
    this.maxDocs = data
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/view-form/view-form.component.ts